import React, { useMemo, Fragment } from 'react'
import * as styles from './index.module.scss'

const DES_TYPE = {
    TEXT: 'TEXT',
    IMAGE: 'IMAGE'
}

function interlaceImg(url) {
    return `${url}?x-oss-process=image/format,jpg/interlace,1`;
}
const Details  = ({product}) => {

  const attribute = useMemo(() => {
    const info = [];
    const material = product?.attributes?.attributes?.material?.choices;
    const detail = product?.keyDetails;
    const origin = product?.attributes?.attributes?.origin?.choices;
    material?.length && info.push({label: '材质', value: material});
    detail?.length && info.push({label: '细节', value: detail});
    origin?.length && info.push({label: '产地', value: origin});
    return info
  }, [product])

  const description = product?.imageText?.layers || []

  return (
    <div className={styles.details}>
      {
        attribute.length ? (
          <>
            <div className={`${styles.title} ${styles.parameter}`}>
              商品参数
            </div>
            <div className={`${styles.parameterMain} ${styles.main}`}>
              {
                attribute.map((item, index) => (
                  <div className={styles.parameterItem} key={index}>
                    <div className={styles.parameterItemTitle}>
                      {item.label}：
                    </div>
                    <div className={styles.parameterItemContext}>
                      {item.value}
                    </div>
                  </div>
                ))
              }
            </div>
          </>
        ) : null
      }
      {
        description.length ? (
          <>
            <div className={`${styles.title} ${styles.description}`}>
            商品描述
            </div>
            <div className={`${styles.descriptionMain} ${styles.main}`}>
              {
                description.map((item, index) => {
                  return (
                    <Fragment key={index}>
                      {
                        item.layerType === DES_TYPE.TEXT && (
                          <div className={styles.descriptionItem}>
                            {item?.text?.text}
                          </div>
                        )
                      }
                      {
                        item.layerType === DES_TYPE.IMAGE && (
                          <div className={`${styles.descriptionItem} ${styles.image}`}>
                            <img src={interlaceImg(item?.image?.url)} />
                          </div>
                        )
                      }
                    </Fragment>
                  )
                })
              }
            </div>
          </>) : null
      }
    </div>
  )
}

export default Details